'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MARKER_MOUNTED = exports.MARKER_MOUNTED = 'MARKER_MOUNTED';
var MARKER_UNMOUNTED = exports.MARKER_UNMOUNTED = 'MARKER_UNMOUNTED';
var HISTORY_CHANGED = exports.HISTORY_CHANGED = 'HISTORY_CHANGED';
var TIMEDOUT = exports.TIMEDOUT = 'TIMEDOUT';